export default {
  SET_DOMAIN_CONFIG: "SET_DOMAIN_CONFIG",
  SET_IS_TOPUP_ENABLED_IN_APPLICATION: "SET_IS_TOPUP_ENABLED_IN_APPLICATION",
};
